import React from "react";
import { easyonFaqItems } from "../../data/easyonPageContent";
import { CrmFaqSection } from "../crm/CrmFaqSection";
import "../../styles/crm-product.css";

export const EasyonFaqSection = () => {
    return (
        <CrmFaqSection
            title="Frequently Asked Questions"
            lead="Everything you need to know about EasyOn — the business operations automation platform."
            items={easyonFaqItems}
            showEyebrow={false}
        />
    );
};
